<template>
  <div class="app-container">
    <list ref="list"
    @setSupplier="setSupplier"
    @check-change="checkChange"
    >
      <template slot="toolbar-right">
        <el-button size="mini" type="primary" @click="_create"
          :disabled="data.length === 0"
          >一键生成请购单</el-button
        >
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" :goods="data" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/purchase/business/purchasing/list";
import editDialog from '@/components/purchase/business/purchasing/editDialog'

export default {
  name: "receipt",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data() {
    return {
      api: require("@/api/fund/receipt").default,
      data: [],
      _data: [],
    };
  },
  
  methods: {
    // 将多余的属性删除
    checkChange(rows){
      this.data = rows;
      // let _rows = JSON.parse(JSON.stringify(rows))

      // _rows.forEach((value) => {
      //   delete value.isShow
      // })
      // this.data = _rows;
      
    },
    // 供应商选择
    setSupplier({row, oldTradeUnitName, oldTradeUnitId, tradeUnitId, tradeUnitName}){
      console.log(row)
      let tempRow = JSON.parse(JSON.stringify(row));
      delete tempRow.isShow;
      tempRow.TradeUnitName = oldTradeUnitName;
      tempRow.TradeUnitId = oldTradeUnitId;
      let _tempRow = JSON.stringify(tempRow)
      let dataLength = this.data.length;
      console.log('oldData==============', this.data)
      for(let i = 0; i < dataLength; ++i){
        let _item = JSON.stringify(this.data[i]);
        console.log('_tempRow', _tempRow)
        console.log('_item', _item)
        console.log('_tempRow===_item',_tempRow === _item)

        if(_tempRow === _item){
          this.data[i].TradeUnitName = tradeUnitName;
          this.data[i].TradeUnitId = tradeUnitId;
          console.log('data==================', this.data)
          return;
        }
      }
     
    },
    _create(){
   
      this.$refs.editDialog.openCreate().then(that => {
        that.setGoodList();
      })
     
     
    }
  
  },
};
</script>